import * as React from "react";
import "./PreferenceNumber.component.css";
import { useEffect, useState } from "react";
import { preferencesService } from "../../../../modules/preferences/PreferencesService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ttResetToDefaultButtonDisabled, ttResetToDefaultButton } from "../../../common-strings.util";
export function PreferenceNumber({ type, label, preferenceName, min, max, step, defaultValueFallback = undefined, inline = false, disabled = false, showValue = false, decimalPlaces, tooltip, tooltipDisabled, tooltipPosition }) {
    const [currentValue, setCurrentValue] = useState(undefined);
    const [defaultValue, setDefaultValue] = useState(undefined);
    useEffect(() => {
        const schemaObj = preferencesService.schema.preferences.properties[preferenceName];
        let defaultVal;
        if (schemaObj !== undefined && schemaObj.type && schemaObj.type === "number") {
            defaultVal = schemaObj.default;
        }
        else if (defaultValueFallback !== undefined) {
            defaultVal = defaultValueFallback;
        }
        setDefaultValue(defaultVal);
        const updateFromPreferences = () => {
            var _a;
            setCurrentValue((_a = preferencesService.getNumberPreferredValue(preferenceName, defaultVal)) !== null && _a !== void 0 ? _a : defaultVal);
        };
        updateFromPreferences();
        preferencesService.onStoreChanged.add(updateFromPreferences);
        return () => preferencesService.onStoreChanged.remove(updateFromPreferences);
    }, [defaultValueFallback, preferenceName]);
    const updateValue = (value) => {
        setCurrentValue(value);
        if (value !== undefined)
            preferencesService.updatePreferences([{ key: preferenceName, value }]);
    };
    const handleSliderChange = (event) => {
        updateValue(parseFloat(event.target.value));
    };
    const displayValue = decimalPlaces === undefined ? (currentValue !== null && currentValue !== void 0 ? currentValue : 0) : Number((currentValue !== null && currentValue !== void 0 ? currentValue : 0).toFixed(decimalPlaces));
    return (React.createElement("div", { className: `preference-number ${disabled ? "preference-number-disabled" : ""}`, style: inline ? { width: "unset" } : {} },
        React.createElement("label", null, label),
        React.createElement("input", { "aria-label": label, type: type === "slider" ? "range" : "number", min: min, max: max, step: step, value: type === "slider" ? (currentValue !== null && currentValue !== void 0 ? currentValue : 0) : displayValue, onChange: handleSliderChange, disabled: disabled, className: type === "slider" ? "preference-number-slider" : "preference-number-input", "data-tooltip": tooltip, "data-tooltip-disabled": tooltipDisabled, "data-tooltip-position": tooltipPosition }),
        type === "slider" && showValue && (React.createElement("output", { className: "preference-number-value", "aria-label": label }, displayValue)),
        React.createElement("button", { className: "icon-button", onClick: () => {
                updateValue(defaultValue);
            }, disabled: currentValue === defaultValue, "data-tooltip": ttResetToDefaultButton(), "data-tooltip-disabled": ttResetToDefaultButtonDisabled(), "data-tooltip-position": tooltipPosition },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "undo"] }))));
}
